import React, { createContext, useContext, useState, useCallback } from 'react';
import { Dialog } from '@material-ui/core';

const DialogContext = createContext(null);

export const useDialog = () => useContext(DialogContext);

export const DialogProvider = ({ children }) => {
    const [dialogs, setDialogs] = useState([]);

    const openDialog = renderContentFn => {
        const id = crypto.randomUUID();

        const closeDialog = () => {
            setDialogs(prev => prev.filter(dialog => dialog.id !== id));
        };

        const content = renderContentFn({ closeDialog });

        setDialogs(prev => [...prev, { id, content }]);

        return { id };
    };

    const closeDialog = useCallback(id => {
        if (dialogs.length > 1) {
            setDialogs(prev => prev.filter(dialog => dialog.id !== id));
        } else {
            setDialogs([]);
        }
    }, []);

    const closeAllDialogs = useCallback(() => {
        setDialogs([]);
    }, []);

    return (
        <DialogContext.Provider value={{ openDialog, closeDialog, closeAllDialogs }}>
            {children}
            {dialogs.map(({ id, content }) => (
                <Dialog key={id} open onClose={() => closeDialog(id)} maxWidth="lg">
                    {content}
                </Dialog>
            ))}
        </DialogContext.Provider>
    );
};
